import React, { useState, useRef, useEffect, useImperativeHandle } from "react";
import { useNavigate } from "react-router-dom";
import ImageComponet from "../../components/ImageComponet/imageComponet";
import { useLoader } from "../../components/loader/loader";
import NoRecord from "../../components/NoDataScreen/NoRecord";
import VideoComponet from "../../components/VideoComponet/VideoComponet";
import { ApiUrl } from "../../config/apiConfig";
import { PaginationControls } from "../../models/pagination";
import { getData, postData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";
import AddMarketNewRelease from "../MarketNewRelease/AddMarketNewRelease";
import Pagination from "../../components/pagination/pagination";
import icon from "../../assets/img/downbtn.svg";
import Add_IFTA_Feature from "./Add_IFTA_Feature";
import { PaginationControls2 } from "../../models/pagination2";
import { ChevronsUpDown } from "lucide-react";
import EditButton from "../../components/UIElements/EditButton";
// import { FaEdit } from 'react-icons/fa'; 



interface NewList {
  allData: any;
  setAllData: any
}

const IFTAFeature = React.forwardRef((props: NewList, ref) => {
  const { show, hide } = useLoader();

  const [searchdata, setSearchQuery] = useState<any>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [SingleMarketResearch, setMarketResearch] = useState("");
  const hide3 = useRef<any>(null);

  const [pagination, setPagination] = useState(new PaginationControls2());
  const [startIndex, setStartIndex] = useState(0);



  const closeModal = () => {
    setIsModalOpen(false);
  };


  useEffect(() => {
    getDataALL(searchdata);

    return () => { };
  }, [pagination.page, searchdata]);

  const getDataALL = async (searchdata?: any) => {

    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    if (searchdata) {
      obj.search = searchdata;
    }
    try {
      const response = await getData(ApiUrl.listIftaTaxrate, obj, {
        show,
        hide,
      });
      console.log(response);
      props.setAllData(response.data);

      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );
    } catch (error) { }
  };

  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  useImperativeHandle(ref, () => ({
    getDataALL,

    handleSearchSubmit,
    handleSearchChange,
  }));

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    getDataALL(searchdata);
  };







  let addEdit = (data?: any) => {

    if (data) {
      console.log("LoadDetails >>>>>>>>>>>>>", data);
      setMarketResearch(data);
      setIsModalOpen(true);
    }
  };



  return (
    <>
      <div className="loadlist">
        <div className="tablebox">
          <div className="tablebox12">
            <div className="scrollbar-box">


              <table className="border-collapse  text-black w-full">
                <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                  <tr className="text-[13px] font-bold  bg-customGray">
                    <th className="px-3 py-2 text-center border border-[#E2E2E2] ">
                      <div className="flex items-center justify-between">
                        <span>S. No</span>
                        <ChevronsUpDown size="12px" />
                      </div>
                    </th>

                    <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                      <div className="flex items-center justify-between">
                        <span>States</span>
                        <ChevronsUpDown size="12px" />
                      </div>
                    </th>

                    <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                      <div className="flex items-center justify-between">
                        <span>Tax rate</span>
                        <ChevronsUpDown size="12px" />
                      </div>
                    </th>



                    <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                  {props.allData.map((data: any, index: number) => (
                    <tr key={index} className="text-[12px]">
                      <td className="  px-3  border border-[#E2E2E2]">
                        {(pagination.page - 1) * pagination.limit + index + 1}
                      </td>
                      <td className=" px-3 border border-[#E2E2E2]">
                        {data.states ? data.states : '--'}
                      </td>
                      <td className="px-3 border border-[#E2E2E2]">
                        {data.state_tax_Rate != null ? `$${Number(data.state_tax_Rate.toFixed(4))}` : '--'}
                      </td>

                      <td className=" text-center  items-center px-2 py-[2px] border border-[#E2E2E2]">
                        <div className=" w-full flex justify-center gap-1 items-center ">
                          <EditButton onClick={() => addEdit(data)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {!props.allData.length && (
                <NoRecord noDataText="No data available in IFTA" />
              )}
            </div>
          </div>
          {props.allData.length > 0 && (
            <Pagination pagination={pagination} onPageChange={handlePageChange} />
          )}
        </div>
      </div>


      <Add_IFTA_Feature
        isOpen={isModalOpen}
        openModal={SingleMarketResearch}
        closeModal={closeModal}
        ref={hide3}
        getDataALLs={getDataALL}
      />
    </>
  );
});

export default IFTAFeature;

